import ControlViewModel from "@/ViewModels/ControlViewModel";
import ComponentManager from "@/Management/ComponentManager";
import LinkViewModel from "@/ViewModels/Controls/LinkViewModel";
import { INavigationItemViewModelConstructorParameter } from "#/DefaultViewExtensionInterfaces";
import ImageViewModel from "@/ViewModels/Controls/ImageViewModel";

export default class NavigationItemViewModel extends ControlViewModel {
    public isSelected: KnockoutObservable<boolean>;
    public onItemClick: () => void;
    public linkViewModel: LinkViewModel;
    public childNodes: KnockoutObservableArray<NavigationItemViewModel>;
    public isNodeExpanded: KnockoutObservable<boolean>;
    public hasAction: KnockoutObservable<boolean>;
    public recentExpandedState: KnockoutObservable<boolean>;

    public expandIcon: ImageViewModel;
    public moduleIcon: ImageViewModel;

    public constructor(params: INavigationItemViewModelConstructorParameter) {
        super(params);

        this.childNodes = this.observableOrDefault(params.childNodes, []) as KnockoutObservableArray<NavigationItemViewModel>;
        this.isSelected = this.observableOrDefault(params.isSelected, false);
        this.isNodeExpanded = this.observableOrDefault(params.isNodeExpanded, false);
        
        this.linkViewModel = this.paramOrDefault(params.linkViewModel, null);
        this.expandIcon = this.paramOrDefault(params.expandIcon, null);
        this.moduleIcon = this.paramOrDefault(params.moduleIcon, null);
        this.hasAction = this.observableOrDefault(params.hasAction, false);
        
        this.recentExpandedState = this.observableOrDefault(this.isNodeExpanded());
        
        this.onItemClick = this.handlerOrDefault(params.onItemClick, () => {});
    }

    public isNodeExpandable(): boolean {
        return this.childNodes.length > 0;
    }
}

ComponentManager.setViewModel('NavigationItemViewModel', NavigationItemViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');